import React from 'react';
import { AiOutlineForm } from 'react-icons/ai';

const Sucesiones = () => {

    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-3xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Requisitos para Sucesiones </h1>

                <ul className='list-disc list-inside font-sans text-lg'>
                    <li>Poder legalmente conferido</li>
                    <li>Copia auténtica del registro civil de defunción de(los) causante(s)</li>
                    <li>Copia auténtica del registro civil de matrimonio</li>
                    <li>Copia auténtica de los registros civiles de nacimiento de los herederos</li>
                    <li>Fotocopias de cedulas de ciudadania de causantes y herederos</li>
                    <li>Paz y salvo de impuesto predial de los bienes año actual</li>
                    <li>Paz y salvo de valorización año actual (cuando los bienes se ubican en sector urbano)</li>
                    <li>Paz y salvo de administración (cuando los bienes se encuentran sometidos a régimen de propiedad horizontal)</li>
                    <li>Certificado de tradición y libertad de los bienes, no mayor a 30 dias de expedido</li>
                    <li>Licencia de tránsito (cuando existen vehículos)</li>
                    <li>Pago de impuesto de vehículo</li>
                    <li>Certificación bancaria (cuando han quedado obligaciones, cuentas, CDTs etc)</li>
                    <li>Copias simples de las escrituras publicas</li>
                    <li>Declaración de renta</li>

                    <h2 className='font-bold text-principal text-2xl text-center py-5'>Gastos</h2>

                    <li>Honorarios de abogado</li>
                    <li>Gastos de publicaciones por prensa y radio</li>
                    <li>Gastos notariales (van de acuerdo al avaluó de los bienes)</li>
                    <li>Gastos de tesorería (van de acuerdo al avaluó de los bienes)</li>
                    <li>Gastos de registro (van de acuerdo al avaluó de los bienes)</li>

                </ul>

                <div className='pt-10 pb-5'>
                    <a
                        href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Sucesiones.`} target="_blank" rel="noopener noreferrer"
                        className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                        <AiOutlineForm size={25} className='inline-block mr-2' />
                        Solicitar
                    </a>
                </div> 

            </div>
        </div>

    );
}

export default Sucesiones;